import { Projects, Contacts, PendingContacts, Versions, VelaInput, VelaTemplate } from '@usimweb/core/models';

export interface ProjectsState {
  entities: { [uuid: string]: Projects };
  loaded: boolean;
  loading: boolean;
}

export interface VersionsState {
  entities: { [uuid: string]: Versions };
  loaded: boolean;
  loading: boolean;
}

export interface ContactsState {
  entities: { [pk: string]: Contacts };
  pending: { [pk: number]: PendingContacts };
  invites: { [pk: number]: PendingContacts };
  loaded: boolean;
  loading: boolean;
}

export interface VelaTreeState {
  entities: { [name: string]: VelaTemplate };
  velaInput: VelaInput;
  loaded: boolean;
  loading: boolean;
}

export class MakeEntitie {
  public static projects(state: ProjectsState, projects: Projects[]) {
    const entities = projects.reduce(
      (entities: { [uuid: string]: Projects }, projects: Projects) => {
        return {
          ...entities,
          [projects.uuid]: projects,
        };
      },
      {
        ...state.entities,
      }
    );
    return entities;
  }

  public static project(state: ProjectsState, projects: Projects) {
    const updatedEntities = {
      ...state.entities,
      [projects.uuid]: projects,
    };

    return updatedEntities;
  }

  public static versions(state: VersionsState, versions: Versions[]) {
    const entities = versions.reduce(
      (entities: { [uuid: string]: Versions }, versions: Versions) => {
        return {
          ...entities,
          [versions.uuid]: versions,
        };
      },
      {
        ...state.entities,
      }
    );
    return entities;
  }

  public static contacts(state: ContactsState, contacts: Contacts[]) {
    const entities = contacts.reduce(
      (entities: { [username: string]: Contacts }, contacts: Contacts) => {
        return {
          ...entities,
          [contacts.username]: contacts,
        };
      },
      {
        ...state.entities,
      }
    );
    return entities;
  }

  public static pending(state: ContactsState, pendingContacts: PendingContacts[]) {
    const entities = pendingContacts.reduce(
      (entities: { [pk: number]: PendingContacts }, pendingContacts: PendingContacts) => {
        return {
          ...entities,
          [pendingContacts.pk]: pendingContacts,
        };
      },
      {
        ...state.pending,
      }
    );
    return entities;
  }

  public static invite(state: ContactsState, inviteContacts: PendingContacts[]) {
    const entities = inviteContacts.reduce(
      (entities: { [pk: number]: PendingContacts }, inviteContacts: PendingContacts) => {
        return {
          ...entities,
          [inviteContacts.pk]: inviteContacts,
        };
      },
      {
        ...state.invites,
      }
    );
    return entities;
  }

  public static velaTemplate(state: VelaTreeState, template: VelaTemplate[]) {
    const entities = template.reduce(
      (entities: { [name: string]: VelaTemplate }, template: VelaTemplate) => {
        return {
          ...entities,
          [template.name]: template,
        };
      },
      {
        ...state.entities,
      }
    );
    return entities;
  }
}
